var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLikeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.166 40.984"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.617 40.734h-9.235a15.08 15.08 0 01-5.278-.949L9.91 37.113a1.6 1.6 0 111.114-3l7.194 2.672a11.914 11.914 0 004.165.746h9.235a1.515 1.515 0 000-3.029 1.6 1.6 0 110-3.2h2.179a1.515 1.515 0 000-3.029 1.6 1.6 0 010-3.2h2.178a1.515 1.515 0 100-3.029 1.6 1.6 0 110-3.2h2.179a1.515 1.515 0 000-3.03h-15.1a1.6 1.6 0 01-1.4-2.371 10.679 10.679 0 00.98-3.126 8.484 8.484 0 00-1.324-6.262 1.309 1.309 0 00-2.38.746c.052 5.476-2.478 9.455-7.316 11.51a1.6 1.6 0 11-1.246-2.926 8.446 8.446 0 004.322-3.738 9.884 9.884 0 001.048-4.8 4.507 4.507 0 018.224-2.575 12.053 12.053 0 011.437 10.36h12.755a4.712 4.712 0 012.088 8.935 4.718 4.718 0 01-2.178 6.226 4.718 4.718 0 01-2.179 6.227 4.714 4.714 0 01-4.263 6.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 38.367H1.849a1.6 1.6 0 01-1.6-1.6V14.854a1.6 1.6 0 011.6-1.6H11a1.6 1.6 0 011.6 1.6v21.915a1.6 1.6 0 01-1.6 1.6zm-7.55-3.2h5.951V16.452H3.447z"
  }))));
}

export default SvgLikeinline;